import parseTree from "./parse_tree";
type ActionType =
  | "take_challenge"
  | "replay_challenge"
  | "rewind_challenge"
  | "unknown";

class CGAPIBcloksPayload {
  private bk_action_bloks_AsyncAction = "bk.action.bloks.AsyncAction";
  private bk_action_bloks_InflateSync = "bk.action.bloks.InflateSync";
  private ig_action_navigation_ClearChallengeWithParams =
    "ig.action.navigation.ClearChallengeWithParams";
  private ig_action_navigation_LoginWithParam =
    "ig.action.navigation.LoginWithParam";
  private ig_action_navigation_OpenDialog = "ig.action.navigation.OpenDialog";
  private ig_action_navigation_ClearChallenge =
    "ig.action.navigation.ClearChallenge";
  private bk_action_io_Toast = "bk.action.io.Toast";
  private ig_action_navigation_OpenScreen = "ig.action.navigation.OpenScreen";
  private ig_action_challenges_InsertAndPopToScreen =
    "ig.action.challenges.InsertAndPopToScreen";

  private ig_action_navigation_PresentModalWithModalObject =
    "ig.action.navigation.PresentModalWithModalObject";
  private ig_action_navigation_CloseModalWithResult =
    "ig.action.navigation.CloseModalWithResult";

  private challengeInfo: any = {};
  private parsedData = [];

  private challegeAction: any = [];
  private cachChallengeAction: any = [];

  private toastData = "";
  private dialogMessage = null;

  private userInfo: any = null;

  private methodsWay = "";
  private verifyWay: any = null;

  private cachMethodsValue: any = [];

  public getChallengeAction() {
    return this.challegeAction;
  }

  public getMethodWay() {
    return this.methodsWay;
  }

  public getVerifyWay() {
    return this.verifyWay;
  }

  public getToastData() {
    return this.toastData;
  }

  public getDialog() {
    return this.dialogMessage;
  }

  public getCachMethodsValue() {
    return this.cachMethodsValue;
  }

  public setChallengeInfo(info: any) {
    this.challengeInfo = info;
  }

  public getChallengeInfo() {
    return this.challengeInfo;
  }

  public getUserInfo() {
    return this.userInfo;
  }

  public clearChallengeParams() {
    this.userInfo = null;
    this.cachChallengeAction = this.challegeAction = this.parsedData = [];
    this.dialogMessage = null;
    this.toastData = "";
  }

  public async init(data: any) {
    this.cachChallengeAction = [];
    this.dialogMessage = null;
    this.toastData = "";
    const parseString: any = await this.checkPayload(data);
    this.parsedData = parseTree(parseString);
    console.log("this.parsedData", this.parsedData);
    this.filterData(this.parsedData);
    if (this.cachChallengeAction.length > 0) {
      this.challegeAction = this.cachChallengeAction;
    }
  }

  public preferredChallengeAction(
    action_type: ActionType,
    selectChoice?: number
  ) {
    console.log("preferredChallengeAction ", this.challegeAction, action_type);
    const filterActions = this.challegeAction.filter(
      (item: any) => item.type === action_type
    );
    if (action_type === "take_challenge" && filterActions.length > 0) {
      for (const j of filterActions) {
        const { step_data } = j;
        let choice = step_data.choice;
        if (typeof choice === "string") {
          choice = parseInt(choice);
        }

        if (choice === selectChoice) {
          console.log(" preferredChallengeAction j", j);
          return step_data;
        }
      }
    }
    console.log("filterActions", filterActions);
    if (filterActions.length > 0) {
      return filterActions[0].step_data;
    } else {
      return {
        error_type: "show_toast",
        message:
          "Something is wrong with your account, please fix it in Instagram.",
        close_page: true
      };
    }
  }

  public clearCallengeInfo() {
    this.challengeInfo = null;
  }

  private checkPayload(data: any) {
    if (!data || data.constructor !== Object) {
      return Promise.reject({
        error_type: "data_layout_invalid",
        message: "data.layout is not a dictionary"
      });
    }
    const { layout } = data;
    if (!layout || layout.constructor !== Object) {
      return Promise.reject({
        error_type: "data_layout_invalid",
        message: "data.layout is not a dictionary"
      });
    }

    const { bloks_payload } = layout;
    if (!bloks_payload || bloks_payload.constructor !== Object) {
      return Promise.reject({
        error_type: "data_bloks_payload_invalid",
        message: "data.layout.bloks_payload is not a dictionary"
      });
    }

    const { tree } = bloks_payload;
    if (!tree || tree.constructor !== Object) {
      return Promise.reject({
        error_type: "data_tree_invalid",
        message: "data.layout.bloks_payload.tree is not a dictionary"
      });
    }
    const treeList = Object.keys(tree);
    const treeValue = tree[treeList[0]];
    if (!treeValue || treeValue.constructor !== Object) {
      return Promise.reject({
        error_type: "data_tree_value_invalid",
        message: "data.layout.bloks_payload.tree.value is not a dictionary"
      });
    }
    const treeValueList = Object.keys(treeValue);
    const treeValuePaload = treeValue[treeValueList[0]];
    if (!treeValuePaload || typeof treeValuePaload !== "string") {
      return Promise.reject({
        error_type: "data_payload_string_invalid",
        message:
          "data.layout.bloks_payload.tree.value.payload.string is not a string"
      });
    }
    return treeValuePaload;
  }

  private filterData(data: any[]) {
    for (const j of data) {
      if (Array.isArray(j)) {
        this.filterData(j);
      } else {
        if (j.value === this.bk_action_bloks_AsyncAction) {
          this.handleAsyncAction(data);
        } else if (
          j.value === this.ig_action_navigation_ClearChallengeWithParams
        ) {
          this.ClearChallengeWithParams();
        } else if (j.value === this.ig_action_navigation_LoginWithParam) {
          this.LoginWithParam(data);
        } else if (
          j.value === this.ig_action_navigation_ClearChallenge ||
          j.value === this.ig_action_navigation_CloseModalWithResult
        ) {
          this.ClearChallenge(data);
        } else if (j.value === this.ig_action_navigation_OpenDialog) {
          this.handleDialog(data);
        } else if (j.value === this.bk_action_io_Toast) {
          this.handleToast(data);
        } else if (
          j.value === this.ig_action_navigation_OpenScreen ||
          j.value === this.ig_action_challenges_InsertAndPopToScreen ||
          j.value === this.ig_action_navigation_PresentModalWithModalObject
        ) {
          this.handleOpenScreen(data);
        }
      }
    }
  }

  private handleOpenScreen(data: any[]) {
    console.log("handleOpenScreen data", data);
    this.cachMethodsValue = [];
    for (const j of data) {
      if (Array.isArray(j) && j[0].value === this.bk_action_bloks_InflateSync) {
        const openScreenData = this.handleData(j[1]);
        console.log("openScreenData", openScreenData);
        this.findPageText(openScreenData);
        console.log("this.methodsWay", this.methodsWay);
        console.log("cachMethodsValue", this.cachMethodsValue);
        this.verifyWay = {};
        for (let i = 0; i < this.cachMethodsValue.length; i++) {
          const iValue = this.cachMethodsValue[i];
          Object.keys(iValue).forEach(key => {
            if (key === ")" && iValue[key].toLocaleLowerCase() === "email") {
              this.verifyWay.email = this.cachMethodsValue[i + 1][")"];
            }
            if (
              key === ")" &&
              iValue[key].toLocaleLowerCase() === "phone number"
            ) {
              this.verifyWay.phone_number = this.cachMethodsValue[i + 1][")"];
            }
          });
        }
        console.log("this.verifyWay", this.verifyWay);
      }
    }
  }

  private flatArray(data: any[]) {
    for (const j of data) {
      if (Array.isArray(j)) {
        this.flatArray(j);
      } else if (j.constructor === Object) {
        this.findPageText(j);
      }
    }
  }

  private findPageText(data: any) {
    Object.keys(data).forEach((item: string) => {
      const itemValue: any = data[item];
      if (item === "㐗") {
        this.cachMethodsValue.push(itemValue);
      }
      if (item === "㑣") {
        console.log("itemvalue", itemValue);
        this.methodsWay = itemValue["#"];
      }
      if (itemValue) {
        if (Array.isArray(itemValue)) {
          this.flatArray(itemValue);
        } else if (itemValue.constructor === Object) {
          this.findPageText(itemValue);
        }
      }
    });
  }

  private handleArrayData(arr: any[]) {
    const list: any[] = [];
    for (const j of arr) {
      list.push(this.handleData(j));
    }
    return list;
  }

  private handleConstData(list: any) {
    return JSON.parse(list[0].value);
  }

  private handleMapData(j: any[]) {
    const obj: any = {};
    const keyList = this.handleData(j[0]);
    const valueList = this.handleData(j[1]);
    for (let i = 0; i < keyList.length; i++) {
      obj[keyList[i]] = valueList[i];
    }
    return obj;
  }

  private handleData(list: any): any {
    if (Array.isArray(list)) {
      if (list.length <= 0) {
        return null;
      }
      const safeList = [...list];
      const { value, type } = safeList.splice(0, 1)[0];
      if (type === "string") {
        return value;
      }
      switch (value) {
        case "bk.action.map.Make":
          return this.handleMapData(safeList);
        case "bk.action.array.Make":
          return this.handleArrayData(safeList);
        case "bk.action.bool.Const":
          return this.handleConstData(safeList);
        case "bk.action.i32.Const":
          return this.handleConstData(safeList);
        case "bk.action.i64.Const":
          return this.handleConstData(safeList);
        case "bk.action.array.Get":
          return this.handleData(safeList[1]);
        case "bk.action.io.Toast":
          return this.handleData(safeList);
        default:
          return this.handleData(safeList);
      }
    } else {
      return list.value;
    }
  }

  private handleAsyncAction(data: any) {
    console.log("handleAsyncAction  data", data);
    const actionObj: any = {};
    const action_type = data[1].value;
    const arr = action_type.split(".");
    actionObj.type = arr[arr.length - 1];
    const step_data = this.handleData(data[2]);
    if (!step_data.bloks_action) {
      step_data.bloks_action = action_type;
    }
    actionObj.step_data = step_data;
    this.cachChallengeAction.push(actionObj);
    console.log("this.cachChallengeAction", this.cachChallengeAction);
  }

  private ClearChallengeWithParams() {
    this.challegeAction = [];
  }

  private handleDialog(data: any) {
    console.log("handleDialog data", data);
    if (this.parsedData.length > 0) {
      const first: any = this.parsedData[0];
      const dialogToast: any = {};
      if (first && first.value === this.ig_action_navigation_OpenDialog) {
        const dialog = this.handleData(data[1][1]);

        Object.keys(dialog).forEach(key => {
          const item = dialog[key];
          if (item.constructor === Object) {
            Object.keys(item).forEach(j => {
              if (j === ")") {
                dialogToast.message = item[j];
              } else if (j === "-") {
                dialogToast.title = item[j];
              }
            });
          }
        });
        this.dialogMessage = dialogToast;
      }
    }
  }

  private handleToast(data: any) {
    console.log("handleToast data", data);
    const first: any = this.parsedData[0];
    if (first.value === this.bk_action_io_Toast) {
      this.toastData = this.handleData(data);
      console.log("this.this.toastData", this.toastData);
    }
  }

  private LoginWithParam(data: any) {
    console.log("LoginWithParam", data);
    this.userInfo = this.handleData(data[1][1])[
      "ig.elements.alien_object.user"
    ];
    console.log("this.userInfo ", this.userInfo);
  }

  private ClearChallenge(data: any) {
    console.log("ClearChallenge data", data);
  }
}

export default new CGAPIBcloksPayload();
